import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BookReview/BookReview.js");
